export default __webpack_public_path__ + "static/realWorldImg3-ba13d2c6ac050b86d673942092d6069c.webp";